import { RouteObject } from "react-router-dom";
import ReconciliationPage from "./reconciliation-page";

const reconciliationRouter: RouteObject[] = [
    {
        path: '',
        element: <ReconciliationPage />
    },
]

export default reconciliationRouter;
